import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const authToken = localStorage.getItem('authToken');
  const userEmail = localStorage.getItem('userEmail');

  console.log('=== PROTECTED ROUTE ===');
  console.log('authToken:', authToken ? 'EXISTS' : 'NULL');
  console.log('userEmail:', userEmail);

  if (!authToken || !userEmail) {
    console.log('REDIRECTING: missing token or email');
    return <Navigate to="/" replace />;
  }

  try {
    const parts = authToken.split('.');
    if (parts.length !== 3) {
      console.log('REDIRECTING: invalid JWT format');
      localStorage.clear();
      return <Navigate to="/" replace />;
    }

    const payload = JSON.parse(atob(parts[1]));
    const isExpired = payload.exp && payload.exp * 1000 < Date.now();
    console.log('expired:', isExpired);
    if (isExpired) {
      console.log('REDIRECTING: token expired');
      localStorage.clear();
      return <Navigate to="/" replace />;
    }

  } catch (error) {
    console.log('REDIRECTING: error parsing token', error);
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  console.log('ACCESS GRANTED');
  return children;
};

export default ProtectedRoute